export default __webpack_public_path__ + "static/media/Stock-Images-Icon.e0827922.png";